const SUPPORT_EMAIL_ADR = 'conconfig@teladoc.com';

export const CCMClientSettingsConfig = {
  genKey: key => (key ? key.replace(/ /g, '_') : ''),
  getSortedOverview: (overview, overviewMap) => {
    if (!overview) return [];
    const overviewKeys = Object.keys(overviewMap);

    return Object.keys(overview).sort((a, b) => {
      if (!overviewKeys.includes(a) || !overviewKeys.includes(b)) return -1;
      if (!overviewMap[a].order) return 1;
      if (!overviewMap[b].order) return -1;
      return overviewMap[a].order - overviewMap[b].order;
    });
  },
  BASE_URL: `/v1/ccm_contracts`,
  REACT_JSON_THEME: 'summerfruit:inverted',
  FIVE_SECONDS: 5000,
  CONFIRM_SUBMIT: 'confirm_submit',
  CHECK_MARK_SYMBOL: '\u2713',
  MAX_GET_VALIDATION_ATTEMPTS: 45,
  STATE_CODES: {
    EXISTS_IN_SF_NOT_ADMIN: 1,
    CODE_IMPORTED_SUCCESFULLY: 2,
    CODE_ALREADY_IMPORTED: 3,
    CODE_NOT_IN_ADMIN_SF: 4,
    CODE_IS_NOT_NET_NEW: 5,
    MULTIPLE_OVERVIEWS_EXIST: 6,
    SALESFORCE_CONNECTION_ERROR: 7,
    CLIENT_IS_COHORT_SCENARIO: 8,
    ALL_OVERVIEWS_INACTIVE: 9
  },

  STATE_DISPLAY_TEXT: {
    EXISTS_IN_SF_NOT_ADMIN: `This client code doesn't exist in admin yet, but it exists in Salesforce.
              \n Do you want to import it?`,
    CODE_IMPORTED_SUCCESFULLY: `Code was imported successfully. If settings look inaccurate please update them in the Salesforce first and then sync them through "Sync" btn on this page.`,
    CODE_ALREADY_IMPORTED: ``,
    CODE_NOT_IN_ADMIN_SF: `The code exists neither in Salesforce nor in Admin. Please create client code in Salesforce first and then import it into admin.`,
    CODE_IS_NOT_NET_NEW: `Core Admin Import is disabled for this client code in Salesforce.
            \nIf you want to import it into admin, please make sure this client code wasn't enabled through TechOps process yet and then check on "Enable Core Admin Import?" checkbox in Salesforce for this client code. `,
    MULTIPLE_OVERVIEWS_EXIST: `Multiple contracts found per client code. Only one active CO under the client code is allowed at this time. Please get in touch with IT support at ${SUPPORT_EMAIL_ADR}`,
    SALESFORCE_CONNECTION_ERROR: `Salesforce is not responding. Please get in touch with IT support at ${SUPPORT_EMAIL_ADR}`,
    CLIENT_IS_COHORT_SCENARIO: `Client cohort scenario detected. This workflow is not supported at this time, please get in touch with IT support at ${SUPPORT_EMAIL_ADR}`,
    ALL_OVERVIEWS_INACTIVE: `All overviews found for the client code are inactive. Please create an active client overview in Salesforce first and then import it into admin`
  },

  CLIENT_OVERVIEW_LABEL_MAP: {
    client_code: { label: 'Client Code', order: 1 },
    name: { label: 'Client Name', order: 2 },
    client_overview_status: { label: 'Client Status', order: 3 },
    billing_method: { label: 'Billing Method', order: 4 },
    population_coverage: { label: 'Population Of Coverage', order: 5 },
    reg_flow_scenarios: { label: 'Registration Flow Scenarios', order: 6 },
    reg_customizations: { label: 'Registration Customizations', order: 7 },
    reg_name: { label: 'Client registration name', order: 8 },
    registration_address_types: { label: 'Registration Address Types', order: 9 },
    mfa: { label: 'Multifactor Authentication', order: 10 },
    insurer_code: { label: 'Insurer Code', order: 11 },
    is_elg_drivertized: { label: 'Is Eligibility Drivertized?', order: 12 },
    account_level_tags: { label: 'Account Level Tags', order: 13 },
    has_one_app_access: { label: 'OneApp Access', type: 'boolean', order: 14 },
    external_tags: { label: 'Client Level Tags', order: 15 },
    program_elg_flag: { label: 'Program Eligibility Flag', type: 'boolean', order: 16 },
    provider_based_care: { label: 'Provider Based Care', type: 'boolean', order: 17 },
    // TODO: Figure out how to calculate parent client code
    // parent_client_code: { label: 'Parent Client Code', order: 18 },
    elg_verification_method: { label: 'Eligibility Verification Method' },
    used_for_registration: { label: 'Used For Registration', type: 'boolean' },
    record_type_name: { label: 'Record Type Name' },
    oneapp_migration_date: { label: 'OneApp Migration Date' }
  },

  PROGRAM_OVERVIEW_LABEL_MAP: {
    launch_date: { label: 'Program Start Date', type: 'date', order: 1 },
    end_date: { label: 'Program End Date', type: 'date', order: 2 },
    status: { label: 'Status', order: 3 },
    reg_status: { label: 'Registration Status', order: 4 },
    program_type: { label: 'Program Type', order: 5 },
    platform_version: { label: 'Program Platform Version', order: 6 },
    enrollment_cap: { label: 'Enrollment Cap', order: 7 },
    qual_dependency: { label: 'Program Qualification Dependency', order: 8 },
    elg_verification_method: { label: 'Eligibility Verification Method', order: 9 },
    cumulative_cap: { label: 'Cumulative Program Cap', order: 10 },
    bmi_limit: { label: 'BMI Limit', order: 11 },
    qual_min_age: { label: 'Qualifications Minimum Age', order: 12 },
    opt_out_questions: { label: 'Opt-out Questions', order: 13 },
    additional_questions: { label: 'Additional Questions', order: 14 },
    confirm_on_no_recruitable_match: { label: 'Confirm On No Recruitable Match', type: 'boolean', order: 15 },
    disable_mental_health_guidance: { label: 'Disable Mental Health Guidance', type: 'boolean', order: 16 },
    disable_teletherapy: { label: 'Disable Teletherapy', type: 'boolean', order: 17 },
    disable_bh_coaching: { label: 'Disable BH Coaching', type: 'boolean', order: 18 },
    ckd_aware_variant: { label: 'Checked Aware variant', type: 'boolean', order: 19 },
    transitioning_dpp: { label: 'Transitioning DPP', type: 'boolean', order: 20 },
    program_name: { label: 'Program Name' }
  },

  DEFAULT_LABEL: { label: '', property: 'text' },

  SYNC_STATUS_MESSAGE_VALIDATION_RESPONSE: {
    IN_PROGRESS: 'IN_PROGRESS',
    PENDING: 'PENDING',
    SUBMITTED: 'SUBMITTED',
    SUCCESSFUL: 'SUCCESSFUL',
    SUCCESS: 'SUCCESS',
    FAILED: 'FAILED'
  },
  CLIENT_CODE_REGEX: /^[a-zA-Z0-9-]+$/,
  CLIENT_CODE_ERR_TEXT: `Client code must only contain letters, numbers, and dashes`,
  GET_VALIDATION_MESSAGES_ERROR: {
    status: 'FAILED',
    error_list: [
      {
        type: 'KAFKA_CONNECTION_ERROR',
        field: '',
        description: `Unable to retrieve validation messages. Please try submitting again or get in touch with IT support at ${SUPPORT_EMAIL_ADR}`
      }
    ]
  }
};
